var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "black",
    fillOpacity: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.143 8.24463L14.933 11.1093C15.1809 11.2859 15.3281 11.5715 15.3281 11.876C15.3281 12.1804 15.1809 12.466 14.933 12.6426L11.1397 15.776C10.8194 16.0302 10.3859 16.0893 10.0094 15.9299C9.6328 15.7705 9.37338 15.4182 9.33299 15.0113V9.0113C9.37193 8.60281 9.63165 8.24854 10.0095 8.0885C10.3873 7.92846 10.8225 7.9884 11.143 8.24463Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideo);
export default __webpack_public_path__ + "static/media/playVideo.88abf9ab04a35b30686ac231f1b03e54.svg";
export { ForwardRef as ReactComponent };